import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import ar from "./locales/ar.json";

i18n
  .use(LanguageDetector) // Auto-detects user language
  .use(initReactI18next) // Initializes React i18next
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    lng: "en", // Default language
    fallbackLng: "en", // Fallback if the selected language is missing
    interpolation: { escapeValue: false },
  });

export default i18n;
